import {LOCALE_ID, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {BccConfirmationComponent, TransitionComponent, TransitionErrorModalComponent} from './transition/transition.component';
import {RecipientComponent} from './transition/recipient/recipient.component';
import {CustomerComponent} from './transition/customer/customer.component';
import {ObjectComponent} from './transition/object/object.component';
import {DocumentHintDialogComponent, DocumentsComponent} from './transition/documents/documents.component';
import {LeadsourceSelectComponent} from './leadsource-select/leadsource-select.component';
import {LeadFormComponent} from './transition/lead-form/lead-form.component';
import {ClearableDatePickerComponent} from './clearable-date-picker/clearable-date-picker.component';
import {EmployeeInvitationConfirmationComponent} from '../employee-invitation-confirmation/employee-invitation-confirmation.component';
import {EmployeeNamePipe} from './pipe/employee-name.pipe';
import {ErrorModalComponent} from '../errorhandler/error-modal/error-modal.component';
import {TenantSelectComponent} from './tenant-select/tenant-select.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatRadioModule} from '@angular/material/radio';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatRippleModule} from '@angular/material/core';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule} from '@angular/material-moment-adapter';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSelectModule} from '@angular/material/select';
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {ToastrModule} from 'ngx-toastr';
import {TokenInterceptor} from '../authentication/token.interceptor';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatExpansionModule} from '@angular/material/expansion';
import {SharedModuleModule} from '../shared/shared-module.module';


const routes: Routes = [
  {path: 'transition', component: TransitionComponent},
  {path: 'employees/:employeeId/office-allocations/:officeAllocationId', component: LeadsourceSelectComponent},
  {path: 'employees/:employeeId/office-allocations/:officeAllocationId/lead-sources/:leadSourceId', component: TransitionComponent},
  {path: 'employee-invitation-confirmation', component: EmployeeInvitationConfirmationComponent},
  {path: '**', component: TransitionComponent}
];
const DATE_PICKER_FORMATS = {
  parse: {
    dateInput: ['DD.MM.YYYY']
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@NgModule({
  declarations: [
    TransitionComponent,
    RecipientComponent,
    CustomerComponent,
    ObjectComponent,
    DocumentsComponent,
    LeadsourceSelectComponent,
    LeadFormComponent,
    BccConfirmationComponent,
    TransitionErrorModalComponent,
    ClearableDatePickerComponent,
    EmployeeInvitationConfirmationComponent,
    ErrorModalComponent,
    TenantSelectComponent,
    DocumentHintDialogComponent,
    EmployeeNamePipe
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatRadioModule,
    MatButtonModule,
    MatProgressBarModule,
    MatRippleModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    MatSelectModule,
    HttpClientModule,
    MatMenuModule,
    MatIconModule,
    ToastrModule.forRoot(
      {
        maxOpened: 5,
        preventDuplicates: true,
        countDuplicates: true,
        timeOut: 5000,
        extendedTimeOut: 8000,
        progressBar: true
      }
    ),
    MatToolbarModule,
    MatExpansionModule,
    SharedModuleModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'de-DE'
    }, {
      provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
      useValue: {useUtc: true}
    },
    {
      provide: LOCALE_ID,
      useValue: 'de-DE'
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: DATE_PICKER_FORMATS
    }
  ]
})
export class LeadFormAppModule {
}
